export const initialValues = {
  title: '',
  discountType: {
    name: '',
    value: ''
  },
  percentageOff: {
    isActive: false,
    discount: '',
    appliesTo: {
      name: '',
      isCategories: false,
      isListings: false,
      value: {
        categories: [],
        listings: []
      }
    },
    notAppliesTo: {
      name: 'None',
      isCategories: false,
      isListings: false,
      value: {
        categories: [],
        listings: []
      }
    }
  },
  dollarOff: {
    isActive: false,
    discount: '',
    discountTo: '',
    appliesTo: {
      name: '',
      isCategories: false,
      isListings: false,
      value: {
        categories: [],
        listings: []
      }
    },
    notAppliesTo: {
      name: 'None',
      isCategories: false,
      isListings: false,
      value: {
        categories: [],
        listings: []
      }
    }
  },
  fixedPrice: {
    isActive: false,
    price: '',
    appliesTo: {
      name: '',
      isCategories: false,
      isListings: false,
      value: {
        categories: [],
        listings: []
      }
    },
    notAppliesTo: {
      name: 'None',
      isCategories: false,
      isListings: false,
      value: {
        categories: [],
        listings: []
      }
    }
  },
  buyXGetY: {
    isActive: false,
    customerBuys: {
      minBuy: {
        name: '',
        value: ''
      },
      appliesTo: {
        name: '',
        isCategories: false,
        isListings: false,
        value: {
          categories: [],
          listings: []
        }
      }
    },
    customerGet: {
      quantity: '',
      appliesTo: {
        name: '',
        isCategories: false,
        isListings: false,
        value: {
          categories: [],
          listings: []
        }
      }
    },
    discountValue: {
      name: '',
      value: ''
    }
  },
  everyNth: {
    isActive: false,
    appliesTo: {
      name: '',
      isCategories: false,
      isListings: false,
      value: {
        categories: [],
        listings: []
      }
    },
    notAppliesTo: {
      name: 'None',
      isCategories: false,
      isListings: false,
      value: {
        categories: [],
        listings: []
      }
    },
    discountOn: {
      name: '',
      value: ''
    },
    discountValue: {
      name: '',
      value: ''
    }
  },
  bundle: {
    isActive: false,
    appliesTo: {
      name: 'Specific Listings',
      value: []
    },
    discountValue: {
      name: '',
      value: ''
    }
  },
  freeShipping: {
    active: false,
    appliesTo: {
      name: 'All Products',
      value: []
    },
  },
  minOrderAmount: {
    name: '',
    value: ''
  },
  customerGroups: {
    name: '',
    value: [],
    specificGroupSelectionCheckbox: false
  },
  usageLimits: {
    perCustomer: {
      name: 'Number of times this discount can be used per customer',
      checked: false,
      value: ''
    },
    shoppingQuantity: {
      name: 'Maximum quantity in shopping cart the discount can be applied to',
      checked: false,
      value: ''
    },
    usageLimitsSelectionCheckbox: false
  },
  exclusionNotes: {
    exclusions: {
      name: 'Exclusions',
      checked: false
    },
    consultationRequired: {
      name: 'Consultation Required',
      checked: false,
    },
    cantCombineWithOffer: {
      name: 'Can’t be combined with any other offer',
      checked: false
    },
    noReturns: {
      name: 'No returns or exchanges',
      checked: false
    },
    onlineOnly: {
      name: 'Valid Online Only',
      checked: false
    },
    suppliesLast: {
      name: 'While Supplies Last',
      checked: false
    },
    other: {
      name: 'Other',
      checked: false,
      value: ''
    }
  },
  specialInstructions: '',
  uploadFile: [],
  dates: {
    isEndDates: false,
    startDate: null,
    startTime: '12:00 AM',
    endDate: null,
    endTime: '11:59 PM'
  },
};

export const defaultCustomerGroups = [
  {
    id: 0,
    code: 'Not Logged In'
  }
];
